module.exports = __webpack_public_path__ + "img/image5.38b84ad.png";